import React, { useEffect, useRef } from "react";
import videojs from "video.js";

export const VideoJS = (props) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const { options } = props;

  useEffect(() => {
    // Asegúra que el reproductor de Video.js se inicialice solo una vez.
    if (!playerRef.current) {
      // El reproductor de Video.js debe estar dentro del elemento del componente para React 18 en el "Modo Estricto".
      const videoElement = document.createElement("video-js");

      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current.appendChild(videoElement);

      const player = (playerRef.current = videojs(
        videoElement,
        options,
        () => {}
      ));
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, videoRef]);

  // Libera el reproductor de Video.js cuando el componente se desmonta
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default VideoJS;
